(function () {
  'use strict';

  var BUTTON_ID = 'CollectionLoadMore';
  var GRID_ID = 'product-grid';

  function getGrid() {
    return document.getElementById(GRID_ID);
  }

  function setLoading(btn, loading) {
    var label = btn.querySelector('[data-label]');
    var spinner = btn.querySelector('[data-spinner]');
    btn.disabled = loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (label) label.textContent = loading ? (btn.dataset.loadingText || 'Loading\u2026') : (btn.dataset.defaultText || 'Load more products');
    if (spinner) spinner.hidden = !loading;
  }

  function stripAnimationClasses(el) {
    el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
    el.removeAttribute('data-cascade');
    el.classList.add('clm-fade-in');
  }

  // Merge current page query params (sort_by, filters, etc.) into a next-page URL.
  // Params already present in nextUrl are left untouched; page= always comes from nextUrl.
  function mergeCurrentParams(nextUrl) {
    var currentParams = new URLSearchParams(window.location.search);
    var qIndex = nextUrl.indexOf('?');
    var base = qIndex !== -1 ? nextUrl.slice(0, qIndex) : nextUrl;
    var nextParams = new URLSearchParams(qIndex !== -1 ? nextUrl.slice(qIndex + 1) : '');

    currentParams.forEach(function (value, key) {
      if (key !== 'page' && !nextParams.has(key)) {
        nextParams.set(key, value);
      }
    });

    return base + '?' + nextParams.toString();
  }

  async function loadMore(btn) {
    var grid = getGrid();
    if (!btn || !grid) return;

    var nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    // Prevent double-click while in flight
    if (btn.getAttribute('aria-busy') === 'true') return;

    nextUrl = mergeCurrentParams(nextUrl);
    setLoading(btn, true);

    try {
      var response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);

      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newItems = doc.querySelectorAll('#' + GRID_ID + ' > li');
      if (newItems.length === 0) {
        var wrapper = btn.closest('.clm-wrapper');
        if (wrapper) wrapper.remove();
        return;
      }

      newItems.forEach(function (item) {
        stripAnimationClasses(item);
        grid.appendChild(item);
      });

      var newBtn = doc.getElementById(BUTTON_ID);
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        var newPage = newBtn.dataset.currentPage;
        var totalPages = newBtn.dataset.totalPages;
        if (newPage) btn.dataset.currentPage = newPage;
        if (totalPages) updateStatus(btn, newPage, totalPages);
        setLoading(btn, false);
      } else {
        var wrapper = btn.closest('.clm-wrapper');
        if (wrapper) wrapper.remove();
      }
    } catch (err) {
      console.error('[Load more] fetch failed:', err);
      setLoading(btn, false);
    }
  }

  function updateStatus(btn, currentPage, totalPages) {
    var status = document.getElementById('ClmStatus');
    if (!status) return;
    status.textContent = 'Page ' + currentPage + ' of ' + totalPages;
  }

  // Event delegation: one listener on document survives any DOM replacement by facets.js
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#' + BUTTON_ID);
    if (!btn) return;
    e.preventDefault();
    loadMore(btn);
  });

})();
